import { useMemo } from 'react';
import CompanyStatCard from "../components/CompanyStatCard";
import SignupCountGraph from '../../admin/dashboard/components/SignupCountGraph';
import CompanyFilters from "../components/CompanyFilters"
import BarStatCard from "../components/BarStatCard";
import Constants from "../../../Constants";
import DollarSignIcon from '../../../assets/icons/paid.svg?react'
import { useCompanySalesContext } from "./context/CompanySalesContext";
import CommissionPayout from "./components/CommissionPayout";
import { renderCompanySalesStatCards } from "./config/superDashboardConfig"
import { dashboardListClasses, dashboardTitleClasses } from "../../../components/common/dashboardClasses";
import { statsGridClasses, chartStatsGridClasses, payoutGridClasses, costTotalTextClasses, costAmountClasses } from "../../../components/common/dashboardGridClasses";
import SuperAdminPageWrapper from "../components/SuperAdminPageWrapper";

const CompanySales = () => {

    const {
        isMRRLoading,
        monthlyRecurringRevenueData,
        totalRevenue,
        currencyFormatter,
        totalAnnualTarget,
        annualTargetLoading,
        totalSignups,
        isLoading
    } = useCompanySalesContext()

    const ytdCommission = useMemo(() => {
        if (!totalAnnualTarget || totalAnnualTarget === 0) return 0;
        return ((totalRevenue / totalAnnualTarget) * 100).toFixed(2);
    }, [totalRevenue, totalAnnualTarget]);

    const statCards = useMemo(
        () =>
            renderCompanySalesStatCards({
                totalSignups,
                totalRevenue,
                totalAnnualTarget,
                currencyFormatter,
                ytdCommission
            }),
        [
            totalSignups,
            totalRevenue,
            totalAnnualTarget,
            currencyFormatter,
            ytdCommission
        ]
    );

    return (
        <SuperAdminPageWrapper>
            <div className={`container ${dashboardListClasses}`}>
                <div className="flex items-center gap-2 mb-6">
                    <h1 className={dashboardTitleClasses}>Sales</h1>
                    <div className="ml-auto">
                        <CompanyFilters />
                    </div>
                </div>
                <div className={`${statsGridClasses} mb-6`}>
                    {statCards.map((card, index) => (
                        <CompanyStatCard
                            key={index}
                            icon={card.icon}
                            title={card.title}
                            value={card.value}
                            isLoading={
                                card.loadingKey === "signup"
                                    ? isLoading
                                    : card.loadingKey === "annualTarget"
                                        ? annualTargetLoading
                                        : false
                            }
                        />
                    ))}
                </div>
                <div className={`${chartStatsGridClasses} mb-6`}>
                    <SignupCountGraph />
                    <BarStatCard
                        title="Client MRR by Account"
                        icon={<DollarSignIcon />}
                        data={monthlyRecurringRevenueData.map((item) =>
                        ({
                            companyName: item.companyName,
                            value: `${item.monthlyRecuringRevenue}`
                        }))}
                        colors={Constants.BarStatColorConstants.MRR}
                        cardIndex={0}
                        isLoading={isMRRLoading}
                        rightContent={
                            <div className={costTotalTextClasses}> Total
                                <span className={`${costAmountClasses} font-bold`}> $
                                    {currencyFormatter(totalRevenue)}
                                </span>
                            </div>}
                            limit={7}
                    />
                </div>
                <div className={payoutGridClasses}>
                    <CommissionPayout />
                </div>
            </div>
        </SuperAdminPageWrapper>
    );
};

export default CompanySales;
